module.exports = "/images/vendor/desiigner-svg/svg/places/island.svg?f695432b553d67d9f914ccb822cc5412";